import { withRenderFlag } from '@beef/react';
import { StatelessSearchInput, useIsMobileDimension } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import React from 'react';
import { connect } from 'react-redux';
import { handleViewAddressInputError } from "../../../../store/blocks/addressVerification/actions/analytics/handleViewAddressInputError";
import { getAddress } from "../../../../store/common/actions/getAddress";
import { handleFocusAddressInput } from "../../../../store/blocks/addressVerification/actions/analytics";
import { isCheckAddressStep, selectAddressInputErrorStatus, selectDropdownOptions, selectFiasAddress } from "../../../../store/blocks/addressVerification/moduleSelectors";
import { selectInputDebounce, selectInputError, selectInputPlaceholder } from "../../../../store/blocks/addressVerification/selectors";
import { setIsAddressErrorStatus, setSelectedAddress } from "../../../../store/blocks/addressVerification/slice";
import { useAddressInput } from "../../hooks/useAddressInput";
export var _AddressInput = function _AddressInput(_ref) {
  var onSearch = _ref.onSearch,
    onSelect = _ref.onSelect,
    options = _ref.options,
    placeholder = _ref.placeholder,
    isError = _ref.isError,
    errorText = _ref.errorText,
    handleErrorStatus = _ref.handleErrorStatus,
    defaultValue = _ref.defaultValue,
    onFocus = _ref.onFocus,
    handleViewErrorStatusAnalytics = _ref.handleViewErrorStatusAnalytics,
    debounce = _ref.debounce;
  var isMobile = useIsMobileDimension();
  var _useAddressInput = useAddressInput({
      onSelect: onSelect,
      isMobile: isMobile,
      isError: isError,
      errorText: errorText,
      handleErrorStatus: handleErrorStatus,
      onFocus: onFocus,
      initValue: defaultValue,
      handleViewErrorStatusAnalytics: handleViewErrorStatusAnalytics
    }),
    inputRef = _useAddressInput.inputRef,
    handleChange = _useAddressInput.handleChange,
    handleSelect = _useAddressInput.handleSelect,
    addressInputValue = _useAddressInput.addressInputValue,
    errorMessage = _useAddressInput.errorMessage,
    handleFocus = _useAddressInput.handleFocus,
    onScrollRight = _useAddressInput.onScrollRight,
    onClickMobile = _useAddressInput.onClickMobile;
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-AddressInput"
  }, /*#__PURE__*/React.createElement(StatelessSearchInput, {
    debounceInterval: debounce || 700,
    errorMessage: errorMessage,
    inputRef: inputRef
    // @ts-expect-error передача null для удаления дефолтной иконки поиска в инпуте
    ,
    leftAside: null,
    onBlur: onScrollRight,
    onChange: handleChange,
    onClick: onClickMobile,
    onFocus: handleFocus
    // @ts-expect-error fixme later
    ,
    onSearch: onSearch,
    onSelect: handleSelect,
    options: options,
    placeholder: placeholder,
    value: addressInputValue
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    placeholder: selectInputPlaceholder(state),
    options: selectDropdownOptions(state),
    shouldRender: isCheckAddressStep(state),
    isError: selectAddressInputErrorStatus(state),
    errorText: selectInputError(state),
    defaultValue: selectFiasAddress(state),
    debounce: selectInputDebounce(state)
  };
};
var mapDispatchToProps = {
  onSearch: getAddress,
  onSelect: setSelectedAddress,
  onFocus: handleFocusAddressInput,
  handleErrorStatus: setIsAddressErrorStatus,
  handleViewErrorStatusAnalytics: handleViewAddressInputError
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var AddressInput = compose(connector, withRenderFlag)(_AddressInput);